export const categories = [
  {
    slug: 'kexue-zhishi',
    name: '科学知识',
    description: '从医学和生物学角度，科学解读初次性行为的身体变化与生理机制',
    icon: 'ri-flask-line',
    color: 'primary',
  },
  {
    slug: 'xinli-zhunbei',
    name: '心理准备',
    description: '帮助你理解初次性行为前的心理状态，建立健康的性观念',
    icon: 'ri-heart-pulse-line',
    color: 'accent',
  },
  {
    slug: 'anquan-fanghu',
    name: '安全防护',
    description: '避孕措施、性传播疾病预防等安全性行为必备知识',
    icon: 'ri-shield-check-line',
    color: 'secondary',
  },
  {
    slug: 'changjian-wuqu',
    name: '常见误区',
    description: '打破关于初次性行为的谣言与误解，建立科学正确的认知',
    icon: 'ri-lightbulb-flash-line',
    color: 'primary',
  },
];

export const articles = [
  {
    id: '1',
    slug: 'chunvmo-zhenxiang',
    title: '处女膜的科学真相：它究竟是什么？',
    excerpt: '处女膜并非一层封闭的"膜"，而是阴道口周围的一圈组织褶皱。每个人的处女膜形态各不相同，有些人天生就没有明显的处女膜组织。',
    content: `## 处女膜的科学定义

处女膜（hymen）是位于阴道口周围的一圈薄膜状组织褶皱，而非人们通常想象的一层完全封闭的"膜"。它是在胚胎发育过程中形成的，属于女性生殖系统的正常解剖结构。

## 处女膜的多样性

每个人的处女膜形态都存在差异，主要类型包括：

- **环状处女膜**：围绕阴道口呈环状分布，中间有开口，这是最常见的类型
- **筛状处女膜**：有多个小孔，形似筛子
- **间隔状处女膜**：有组织带横跨阴道口
- **无孔处女膜**：完全封闭，这种情况极为罕见，需要医疗干预

## 处女膜与"第一次"的关系

这是一个需要澄清的关键误区：**处女膜的状态不能作为判断是否有过性行为的依据**。原因如下：

1. 处女膜本身就有开口，以便经血排出
2. 剧烈运动、骑自行车、体操等活动可能导致处女膜组织拉伸
3. 使用卫生棉条也可能影响处女膜形态
4. 部分女性天生处女膜组织就非常少或不明显

## 出血现象的科学解释

初次性行为时的出血，更多是由于阴道组织尚未充分润滑和放松导致的微小撕裂，而非"处女膜破裂"。充分的准备和润滑可以大大减少不适感和出血可能。

## 医学共识

世界卫生组织和各国医学协会均明确指出：处女膜检查不具备任何医学价值，不能作为性行为史的证据。处女膜的状态与道德、贞操等概念毫无科学关联。`,
    category: 'kexue-zhishi',
    author: '李医生',
    authorTitle: '妇产科主治医师',
    readTime: '8 分钟',
    publishDate: '2026-07-15',
    imageQuery: 'Soft warm abstract illustration of anatomical education with gentle coral and peach tones, simple clean medical education style, minimal composition with organic flowing shapes representing body positivity, warm neutral background',
  },
  {
    id: '2',
    slug: 'diyici-xingwei-shenli-bianhua',
    title: '初次性行为的身体变化：你需要知道的生理常识',
    excerpt: '了解初次性行为时身体可能发生的生理反应，包括激素变化、身体感受等，帮助你减少不必要的焦虑和紧张。',
    content: `## 身体的自然反应

初次性行为时，身体会经历一系列自然的生理反应，了解这些可以帮助你减少焦虑：

### 激素变化
- 催产素（拥抱激素）分泌增加，产生亲密感和依恋感
- 多巴胺释放带来愉悦感
- 肾上腺素可能导致心跳加速、呼吸变快

### 女性身体反应
- 阴道润滑增加（充分兴奋的标志）
- 阴蒂充血变大
- 阴道内段扩张（帐篷效应）
- 乳房可能略微增大

### 男性身体反应
- 阴茎勃起
- 睾丸提升靠近身体
- 可能出现少量前列腺液分泌

## 可能的身体感受

初次性行为后的身体感受因人而异，多数人只会经历轻微的不适：

- 部分人可能感到轻微酸痛，通常在1-2天内自然缓解
- 如果使用安全套，部分人对乳胶可能存在过敏反应
- 尿道刺激感（建议事后排尿以减少尿路感染风险）

## 正常与异常：何时需要看医生

**正常现象：**
- 轻微酸痛持续1-2天
- 少量点滴状出血（如有）
- 情绪波动（属心理正常反应）

**需要就医的情况：**
- 持续大量出血
- 剧烈疼痛超过2天
- 异常分泌物或异味
- 排尿疼痛持续超过24小时`,
    category: 'kexue-zhishi',
    author: '王教授',
    authorTitle: '生殖健康专家',
    readTime: '10 分钟',
    publishDate: '2026-07-20',
    imageQuery: 'Artistic abstract representation of human body and wellness with soft peachy warm tones, flowing organic lines suggesting natural bodily rhythms, calm educational medical illustration style, gentle minimalist composition with warm neutral background',
  },
  {
    id: '3',
    slug: 'xinli-zhunbei-zhinan',
    title: '初次性行为前必须做好的五项心理准备',
    excerpt: '心理准备比身体准备更重要。了解自己是否真正准备好了，如何与伴侣沟通，如何在过程中保持舒适和尊重。',
    content: `## 你真的准备好了吗？

决定发生初次性行为是一个重要的个人选择。以下五个方面是你需要认真思考的：

### 1. 内在动机的审视

问自己：这个决定是出于你自己的意愿，还是受到外界压力？
- 是你自己想要探索和体验？
- 是伴侣施加的压力？
- 是害怕"落后"于同龄人？
- 是想通过性来维系关系？

只有当你从内心真正愿意，而非出于压力或恐惧时，才是准备好的状态。

### 2. 对可能后果的认知与接纳

你需要了解并能够接纳可能的结果：
- 关系的可能变化（可能更亲密，也可能疏远）
- 怀孕的可能性及应对方案
- 性传播感染的风险
- 情绪上的波动

### 3. 与伴侣的有效沟通

良好的沟通是舒适性体验的基础：
- 能够坦诚表达自己的感受和顾虑
- 能够明确说出自己的边界和需求
- 能够在任何时刻说"不"并被尊重
- 能够讨论安全措施而不感到尴尬

### 4. 合理的期望管理

初次性行为通常不会像影视作品中那样完美：
- 可能会有笨拙和尴尬的时刻
- 不一定能达到高潮
- 可能需要多次尝试才能找到舒适的节奏
- 这不是一场"表演"，而是两个人共同的探索

### 5. 安全知识储备

心理安心也来自于充分的安全准备：
- 了解并准备好可靠的避孕措施
- 知道如何正确使用安全套
- 了解性传播感染的预防知识
- 知道事后紧急避孕的获取途径`,
    category: 'xinli-zhunbei',
    author: '陈心理咨询师',
    authorTitle: '国家二级心理咨询师',
    readTime: '12 分钟',
    publishDate: '2026-08-01',
    imageQuery: 'Warm minimalist illustration of two people having a gentle caring conversation, soft coral and peach tones, emotional wellness theme, abstract flowing shapes suggesting connection and understanding, calm safe atmosphere, contemporary illustration style',
  },
  {
    id: '4',
    slug: 'goutong-yu-tongyi',
    title: '沟通与知情同意：健康性关系的第一步',
    excerpt: '知情同意（Consent）是任何性行为的基础。了解什么是真正的同意，如何在关系中建立有效的沟通机制。',
    content: `## 什么是知情同意？

知情同意（Informed Consent）是指双方在充分了解情况的前提下，自由、自愿地达成的同意。在性行为中，这意味着：

### 同意的核心要素

**自愿性**：决定必须来自个人自由意志，不受强迫、威胁或操纵
**知情性**：双方都了解将要发生什么以及可能的后果
**清醒性**：酒精或药物影响下的人无法给出有效同意
**持续性**：同意不是一次性的，可以在任何时刻撤回
**具体性**：同意某一行为不代表同意所有行为

## 如何建立有效的沟通

### 直接询问
与其猜测对方的心意，不如直接、温柔地询问。例如：
- "你感觉舒服吗？"
- "你想要继续吗？"
- "这样可以吗？"

### 注意非语言信号
- 身体僵硬或退缩
- 沉默或回避眼神接触
- 不回应或含糊其辞
- 这些可能是不适或不愿意的信号

### 创造安全的沟通环境
- 选择双方都放松的时间和地点
- 使用"我"的句式表达感受
- 认真倾听对方的回应
- 尊重对方的选择，不施压`,
    category: 'xinli-zhunbei',
    author: '陈心理咨询师',
    authorTitle: '国家二级心理咨询师',
    readTime: '9 分钟',
    publishDate: '2026-08-05',
    imageQuery: 'Minimalist abstract illustration representing communication and mutual understanding, two overlapping gentle circles in warm coral and peach, soft watercolor texture, calm and trusting atmosphere, contemporary art style with clean composition',
  },
  {
    id: '5',
    slug: 'biyun-fangfa-quanmian',
    title: '青少年适用的避孕方法全面对比',
    excerpt: '详细了解安全套、口服避孕药、避孕针等各类避孕方法的原理、有效性、优缺点，选择最适合自己的避孕方式。',
    content: `## 为什么避孕很重要？

对于青少年而言，一次无保护的性行为就可能导致意外怀孕。了解并正确使用避孕措施，是对自己和伴侣负责的表现。

## 各类避孕方法对比

### 安全套（男用）
- **有效性**：正确使用时约98%，实际使用约87%
- **优点**：唯一同时预防性传播感染的避孕方法，无需处方，价格低廉
- **缺点**：需要每次使用，可能影响敏感度，少数人对乳胶过敏
- **适用人群**：所有性活跃人群推荐使用

### 短效口服避孕药
- **有效性**：正确服用约99.7%，实际使用约91%
- **优点**：调节月经周期，减轻经期不适
- **缺点**：需每日准时服用，需医生处方，不预防性传播感染
- **注意事项**：有血栓风险的女性需咨询医生

### 紧急避孕药
- **用途**：无保护性行为后的补救措施，72小时内有效
- **注意**：不可作为常规避孕手段，可能引起月经紊乱
- **获取**：药店可购买，建议提前了解就近获取渠道

## 青少年首选推荐

对于初次性行为，**强烈建议使用安全套**，原因如下：
1. 双重保护：同时避孕和预防性传播感染
2. 使用简便，无需提前准备
3. 不含激素，不影响身体发育
4. 随处可得，价格亲民`,
    category: 'anquan-fanghu',
    author: '张药师',
    authorTitle: '临床药师',
    readTime: '11 分钟',
    publishDate: '2026-07-25',
    imageQuery: 'Clean minimalist medical illustration showing various contraceptive options in abstract geometric style, warm beige and sage green tones, educational yet approachable design, soft rounded shapes, calm professional medical aesthetic',
  },
  {
    id: '6',
    slug: 'xingchuanbo-jibing-yufang',
    title: '性传播感染预防：青少年必须知道的事',
    excerpt: '了解常见的性传播感染类型、传播途径、症状表现和预防措施，保护自己和伴侣的健康。',
    content: `## 性传播感染的现状

性传播感染（STIs）在青少年群体中的发病率不容忽视。据统计，全球每年有超过3.7亿新增性传播感染病例，其中15-24岁年龄段占比较高。

## 常见性传播感染类型

### 细菌性感染（可治愈）
- **衣原体感染**：常见且多数无症状，可导致盆腔炎和不孕
- **淋病**：可引起尿道炎、宫颈炎，多重耐药菌株增多
- **梅毒**：分阶段发展，晚期可损害多个器官系统

### 病毒性感染（可控制但多数无法根治）
- **HPV（人乳头瘤病毒）**：最常见的性传播病毒，部分高危型与宫颈癌相关
- **单纯疱疹病毒（HSV）**：引起生殖器疱疹，可复发
- **HIV（人类免疫缺陷病毒）**：导致艾滋病，需终身管理

## 核心预防措施

1. **正确使用安全套**：每次全程使用，可大幅降低感染风险
2. **定期检测**：性活跃人群建议每年至少检测一次
3. **疫苗接种**：HPV疫苗和乙肝疫苗是重要的预防手段
4. **减少性伴侣数量**：伴侣越多，感染风险越高
5. **开放沟通**：与伴侣坦诚交流性健康史和检测状况`,
    category: 'anquan-fanghu',
    author: '赵医生',
    authorTitle: '疾控中心性病艾滋病防治专家',
    readTime: '10 分钟',
    publishDate: '2026-08-02',
    imageQuery: 'Abstract medical infographic style illustration about health protection, soft sage green and warm beige tones, shield-like geometric shapes suggesting protection, clean educational aesthetic with minimal composition, calm reassuring atmosphere',
  },
  {
    id: '7',
    slug: 'diyici-biran-chuxie',
    title: '第一次一定会流血吗？打破处女膜神话',
    excerpt: '"第一次一定会流血"是最普遍的性教育误区之一。事实上，大多数女性初次性行为时并不会出现明显的出血现象。',
    content: `## 这个误区的来源

"初夜必落红"的观念源于古代社会的贞操文化，在那个缺乏科学认知的时代，人们错误地将处女膜出血作为"贞洁"的证明。这一观念在现代社会仍然广泛流传，给无数女性带来了不必要的焦虑和压力。

## 科学事实

**关键数据**：根据现代医学研究，仅有约43%的女性在初次性行为时出现少量出血。这意味着超过半数的女性初次性行为时并不会有明显的出血现象。

原因包括：
1. 处女膜本身就有开口，并非封闭的膜
2. 充分润滑和放松可以避免组织损伤
3. 许多女性的处女膜组织弹性良好
4. 部分女性天生处女膜组织不明显

## 为何这个误区有害

- 导致女性产生不必要的焦虑和恐惧
- 可能被用作对女性进行"贞操检验"的借口
- 使出血不明显的女性担心被误解
- 强化了性别不平等的观念

## 正确观念

性行为中最重要的不是是否出血，而是：
- 双方是否自愿且舒适
- 是否有充分的前戏和润滑
- 是否使用了安全措施
- 是否尊重彼此的感受和边界`,
    category: 'changjian-wuqu',
    author: '李医生',
    authorTitle: '妇产科主治医师',
    readTime: '7 分钟',
    publishDate: '2026-07-28',
    imageQuery: 'Abstract illustration breaking stereotypes with warm coral tones, fragmented geometric shapes dissolving into soft organic forms, symbolizing myth-breaking and truth, contemporary minimalist art style, soft peachy background',
  },
  {
    id: '8',
    slug: 'anquanqi-buhui-huaiyun',
    title: '安全期避孕真的安全吗？性教育常见误区解析',
    excerpt: '很多青少年相信"安全期"可以避孕，但这是极不可靠的方法。我们整理了青少年中最常见的5个性教育误区。',
    content: `## 误区一：安全期可以安全避孕

**真相**：安全期避孕法（或称日历法）的失败率高达24%。原因：
- 青少年的月经周期往往不规律
- 精子可在女性体内存活3-5天
- 排卵时间可能因压力、疾病等因素提前或推迟
- 即使在月经期间也可能排卵

## 误区二：体外射精可以避孕

**真相**：体外射精的失败率约为22%：
- 射精前分泌的前列腺液中可能含有精子
- 时机难以精确控制
- 完全不能预防性传播感染

## 误区三：第一次不会怀孕

**真相**：只要有排卵和精子相遇，就可能怀孕，与第几次性行为完全无关。事实上，青少年时期的生育能力恰恰是最旺盛的。

## 误区四：事后冲洗可以避孕

**真相**：射精后精子在几秒钟内就能进入宫颈，事后冲洗完全无法避孕，反而可能破坏阴道正常菌群平衡。

## 误区五：吃避孕药会不孕

**真相**：现代口服避孕药不会导致不孕。停药后生育能力会恢复正常，有些女性停药后甚至更容易怀孕。

## 正确的态度

面对性教育知识，请记住：
- 信息来源要可靠（医生、专业机构）
- 不要轻信网络传言和同伴经验
- 有疑问时咨询专业医疗人员`,
    category: 'changjian-wuqu',
    author: '张药师',
    authorTitle: '临床药师',
    readTime: '8 分钟',
    publishDate: '2026-08-08',
    imageQuery: 'Conceptual minimalist illustration of myths being dispelled, lightbulb moment theme with warm amber glow, abstract geometric shapes transitioning from confusion to clarity, soft peach and warm beige tones, educational yet artistic style',
  },
];

export const faqs = [
  {
    question: '处女膜真的是一层"膜"吗？',
    answer: '处女膜并非一层封闭的膜，而是阴道口周围的一圈组织褶皱，中间有开口以便经血排出。每个人的形态各不相同，有些人天生就没有明显的处女膜组织。',
  },
  {
    question: '初次性行为一定会出血吗？',
    answer: '不一定。根据医学研究，仅有约43%的女性在初次性行为时出现少量出血。充分的前戏、润滑和放松状态可以大大减少出血的可能。',
  },
  {
    question: '第一次性行为会不会很痛？',
    answer: '每个人的体验不同。充分的准备（前戏、润滑、放松）可以大大减轻不适感。如果感到疼痛，应随时暂停并与伴侣沟通。疼痛通常是可以避免的。',
  },
  {
    question: '什么年龄适合发生初次性行为？',
    answer: '法律规定了最低同意年龄（中国为14岁），但心理和情感的成熟度更为重要。关键在于你是否真正准备好了，而非某个特定的年龄数字。',
  },
  {
    question: '安全套的避孕效果到底有多好？',
    answer: '正确使用时，男用安全套的避孕有效率达98%。但实际使用中（考虑到使用不当等因素）约为87%。关键是每次全程正确使用。',
  },
  {
    question: '紧急避孕药有什么副作用？',
    answer: '可能出现恶心、头痛、月经周期暂时紊乱等。它不应作为常规避孕手段，但作为补救措施是安全有效的。如有严重不适，应咨询医生。',
  },
  {
    question: '如何判断自己是否准备好了？',
    answer: '问问自己：这是出于自己的意愿吗？你了解可能的后果吗？你能和伴侣坦诚沟通吗？你准备好了安全措施吗？如果以上都是肯定的回答，说明你已经有了较好的准备。',
  },
  {
    question: '性传播感染有哪些早期症状？',
    answer: '可能包括异常分泌物、排尿疼痛、生殖器区域瘙痒或皮疹、异常出血等。但很多感染早期无症状，定期检测很重要。',
  },
];